import React from 'react';
import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

// Constants for better maintainability
const COMMON_BENEFITS = [
    {
        id: 'hybrid-working',
        name: "Hybrid working structure",
        icon: "laptop.svg",
    },
    {
        id: 'remote-policies',
        name: "Remote working policies",
        icon: "Work.svg",
    }
];

const INTERN_SPECIFIC_BENEFITS = [
    {
        id: 'project-ownership',
        name: "Project Ownership",
        icon: "project_ownership.svg",
    },
    {
        id: 'career-guidance',
        name: "Career Guidance",
        icon: "career_guidance.svg",
    }
];

const FULL_TIME_SPECIFIC_BENEFITS = [
    {
        id: 'visa-insurance',
        name: "Visa & insurance",
        icon: "Passport.svg",
    },
    {
        id: 'leave-increment',
        name: "Leave increment based on tenure",
        icon: "airplane.svg",
    },
    {
        id: 'learning-platforms',
        name: "Learning platforms",
        icon: "book.svg",
    },
    {
        id: 'career-growth',
        name: "Career growth",
        icon: "ranking.svg",
    }
];

export const OurBenefits = ({ isInternBenefit = false }) => {
    // Build benefits list based on role type
    const benefits_list = isInternBenefit
        ? [...COMMON_BENEFITS, ...INTERN_SPECIFIC_BENEFITS]
        : [...COMMON_BENEFITS, ...FULL_TIME_SPECIFIC_BENEFITS];

    return (
        <div className="careers-benefits-section">
            <div className="careers-heading text-center">
				Our Benefits
            </div>
            <div className={`row ${isInternBenefit ? "alignInternshipBenefits" : ""}`}>
                {benefits_list.map((benefit, i) =>
                    <div className={`${isInternBenefit ? "col-6 col-md-3" : "col-6 col-sm-4 col-md-4 col-lg-2"}`} key={`benefit-${i}`}>
                        <div className="benefit-box">
                            <img src={`${PUBLIC_IMG_URL}/icons/${benefit.icon}`} />
                            <p>{benefit.name}</p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
